import home from "./modules/home"; // 首页

export default [...home];
